import axios from "axios";

const BASE_URL = "https://rtg.goatspins.com";
// const BASE_URL = "http://localhost:3000";


// axios.defaults.baseURL = "https://api.stardustslot.com"
// axios.defaults.baseURL = "http://localhost:3000"; // mora da se promeni da bi gadjalo API u lokalu
axios.defaults.headers.post["Content-Type"] = "application/json";

export const GetApiCall = async (url, baseURL = `${BASE_URL}`, params) => {
  axios.defaults.withCredentials = true;

  let fullUrl = baseURL ? `${baseURL}${url}` : url;
  const paramsKeys = [];

  if (params) {
    Object.keys(params).forEach((key) =>
      paramsKeys.push(key + "=" + encodeURIComponent(params[key]))
    );
    fullUrl = paramsKeys.length
      ? fullUrl + "?" + paramsKeys.join("&")
      : fullUrl;
  }
  let response;
  try {
    response = await axios.get(fullUrl);
  } catch (error) {
    if (error.response) {
      console.error(
        "API responded with an error:",
        error.response.status,
        error.response.data
      );
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error:", error.message);
    }
    throw error;
  }

  if (response.status === 204) return response.status;

  return response.data;
};

export const PostApiCall = async (url, data, baseURL = `${BASE_URL}`) => {
  axios.defaults.withCredentials = true;

  try {
    const response = await axios.post(baseURL + url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    // Ako API vraća status 409 (Conflict), vrati taj error podatak
    if (error.response && error.response.status === 409) {
      return Promise.reject({
        status: 409,
        message: error.response.data?.message || "Conflict error",
      });
    }

    // Za sve ostale greške
    return Promise.reject({
      status: error.response?.status || 500,
      message: error.response?.data?.message || "An unknown error occurred",
    });
  }
};

// dodatna metoda za logovanje na cashier zbog tokena!!!!
export const PostApiCallCashier = async (
  url,
  data,
  baseURL = "https://api.goatspins.com"
) => {
  try {
    const response = await axios.post(baseURL + url, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true, // <--- dodaj ovde!
    });

    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 409) {
      return Promise.reject({
        status: 409,
        message: error.response.data?.message || "Conflict error",
      });
    }

    return Promise.reject({
      status: error.response?.status || 500,
      message: error.response?.data?.message || "An unknown error occurred",
    });
  }
};

export const PutApiCall = async (url, data, baseURL = `${BASE_URL}`) => {
  axios.defaults.withCredentials = true;

  try {
    const response = await axios.put(baseURL + url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const DeleteApiCall = async (url, params, baseURL = BASE_URL) => {
  axios.defaults.withCredentials = true;

  // 1. Formiraj celokupan URL
  let finalUrl = baseURL + url;

  // 2. Ako imaš parametre, dodaj ih kao query string
  if (params) {
    const paramStrings = Object.keys(params).map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    );
    if (paramStrings.length) {
      finalUrl += "?" + paramStrings.join("&");
    }
  }

  try {
    const response = await axios.delete(finalUrl, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    // 4. Ako je 204 (No Content), vrati samo status
    if (response.status === 204) {
      return response.status;
    }

    return response.data;
  } catch (error) {
    // 5. Rukovanje greškama - slično kao PostApiCall
    // Ako API vraća status 409 (Conflict), vrati specifičnu poruku
    if (error.response && error.response.status === 409) {
      return Promise.reject({
        status: 409,
        message: error.response.data?.message || "Conflict error",
      });
    }

    // Za sve ostale greške, vrati generičku poruku
    return Promise.reject({
      status: error.response?.status || 500,
      message: error.response?.data?.message || "An unknown error occurred",
    });
  }
};
